import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
import { GestationalAge } from "@/Patient/Models/ObstetricalFile/GestationalAge";

class Ultrasound {
    public UseForDating: boolean;
    public Date: Date;
    public ClinicalAge: GestationalAge;
    public UltrasoundAge: GestationalAge;
    public Placenta0: string;
    public Placenta1: string;

    constructor(fields?: Partial<Ultrasound>) {
        Object.assign(this, fields);
        this.Date = LuxonDateTimeParser.parse(fields?.Date)?.toJSDate();
        this.ClinicalAge = new GestationalAge(fields?.ClinicalAge);
        this.UltrasoundAge = new GestationalAge(fields?.UltrasoundAge);
    }
}

export { Ultrasound };
